//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
import { computed } from '@vue/composition-api'

export default {
  name: 'CardAction',
  props: {
    title: {
      type: String,
      required: true,
    },
    colorTitle: {
      type: String,
      default: '#FF3232',
    },
    isCustomIcon: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: [String, Object],
      default: () => {},
    },
    sizeIcon: {
      type: Number,
      default: 20,
    },
    colorIcon: {
      type: String,
      default: 'secondary',
    },
    isRow: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const computedTitle = computed(() => props.title)

    return {
      // computed
      computedTitle,
    }
  },
}
